import React, { useMemo } from 'react';

import { EMPTY_GUID } from '../../../constants';
import { AppContextProvider } from '../../../store/App/store';
import { AppEndpoints } from '../../../types/app';
import { OcChatConfig } from '../../../types/oc';
import { Messages, MessageStatus } from "../../Message/types/messages";
import { fetchAiSearchResultData, resumeChatSession, sendChatMessage,sendMessageReaction, trackMessageCopy } from '../services/ocEndpoints';

export type AiAssistantContextProps = typeof AppContextProvider extends React.FC<infer Props> ? Props : never;
export type AiAssistantEndpoints = AiAssistantContextProps['endpoints'];

export const handleMessageReaction = (
    messageKey: string,
    status: MessageStatus,
    sessionKey: string,
    config: OcChatConfig
): Promise<boolean> => sendMessageReaction(config, messageKey, status, sessionKey);

export const handleMessageCopied = (messageId: string, sessionId: string, config: OcChatConfig): Promise<boolean> =>
    trackMessageCopy(config, messageId, sessionId);


export const useDelayInitAiChatEndpoints = (
    config: OcChatConfig,
    processor: (r: Messages) => Messages | Promise<Messages> = (a) => a
): AiAssistantEndpoints => {
    return useMemo<AppEndpoints>(
        () => ({
            initChat: () => Promise.resolve({ sessionId: '', messages: [] }),
            resumeChat: (_, sessionKey) => resumeChatSession(config, sessionKey).then(processor),
            sendMessage: (message, sessionId) => {
                if (!sessionId || !sessionId.length || sessionId === EMPTY_GUID) {
                    return fetchAiSearchResultData(config, message);
                } else {
                    return sendChatMessage(config, message, sessionId);
                }
            },
            handleMessageCopied: (messageId, sessionId) => handleMessageCopied(messageId, sessionId, config),
            handleMessageReaction: (messageId, status, sessionId) => handleMessageReaction(messageId, status, sessionId, config)
        }),
        [config, processor]
    );
};
